import type { CareerLayerApiResponse } from '@/domains/careerLayer/careerLayer.entity';
import type { CareerLayerRepository } from '@/domains/careerLayer/careerLayerData.repository';
import { careerLayerApiService } from '../http/careerLayer.api';

/**
 * Repositorio de datos de capa de carrera con operaciones de lectura
 * Cumple con ISP: interfaz segregada solo para obtención de datos
 */
class CareerLayerApiRepository implements CareerLayerRepository {
  /**
   * Obtiene datos completos de una carrera específica desde la API
   * @param career - Código o identificador de la carrera
   */
  async getCareerLayer(career: string): Promise<CareerLayerApiResponse> {
    const careerLayerResponse =
      await careerLayerApiService.getCareerLayer(career);

    if (!careerLayerResponse) {
      throw new Error('Error al obtener los datos de careerLayer');
    }

    return careerLayerResponse;
  }
}

export const careerLayerApiRepository = new CareerLayerApiRepository();
